import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import useStores from '@stores/useStores';
import { WarehouseSourceOrigin } from '@stores/types';
import { Path } from '@components/routes/constants';

export const withDataGraphAudienceRedirect =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    const { sourcesListStore } = useStores();
    const { id } = useParams<{ id?: string }>() ?? {};

    if (id) {
      const source = sourcesListStore.sourceById(id);
      if (source?.config.origin === WarehouseSourceOrigin.DATA_GRAPH_AUDIENCE) {
        return <Navigate to={Path.DATA_GRAPH_AUDIENCE_DETAILS(id)} replace />;
      }
    }

    return <Component {...props} />;
  };
